import BepMappingDictionary from './dictionary/Bep';
import FepLinearMappingDictionary from './dictionary/FepLinear';
import FepSpotMappingDictionary from './dictionary/FepSpot';
import FepNonLinearMappingDictionary from './dictionary/FepNonLinear';
import RepLinearMappingDictionary from './dictionary/RepLinear';
import * as schema from './schema';
import { IngestFileType } from '../../common/domain/IngestFileType';

const schemaAndDictionaryMap = {
  REP_LINEAR: [schema.RepLinear, RepLinearMappingDictionary],
  FEP_LINEAR: [schema.FepLinear, FepLinearMappingDictionary],
  FEP_SPOT: [schema.FepSpot, FepSpotMappingDictionary],
  FEP_NONLINEAR: [schema.FepNonLinear, FepNonLinearMappingDictionary],
  BEP: [schema.Bep, BepMappingDictionary],
};

export const fileTypeToSchema = (fileType?: IngestFileType) => {
  if (fileType) {
    return schemaAndDictionaryMap[fileType.internalId][0] ?? schema.Bep;
  }
  return schema.Bep;
};

export const fileTypeToColumnDictionary = (fileType?: IngestFileType) => {
  if (fileType) {
    console.log('FileType', fileType);
    return (
      schemaAndDictionaryMap[fileType.internalId][1] ?? BepMappingDictionary
    );
  }
  return BepMappingDictionary;
};
